module.exports = __webpack_public_path__ + "static/img/empty.83d754c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image2/empty.png
// module id = kxfx
// module chunks = 22